import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';
import { ConsolidationSummaryType } from '@/features/dashboard/types';

async function getConsolidationEvolutionAdvanced(params): Promise<ConsolidationSummaryType> {
  const api = await getApi();
  const { data } = await api.get<ConsolidationSummaryType>('/inadimplencia/get_evolution_advanced/', {params});
  return data;
}

type QueryFnType = typeof getConsolidationEvolutionAdvanced;

function useConsolidationEvolutionAdvanced(params) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['fetch-consolidation-inadimplencia-advanced', params],
    queryFn: () => getConsolidationEvolutionAdvanced(params),
  });
}

export { getConsolidationEvolutionAdvanced, useConsolidationEvolutionAdvanced };
